import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useCanAccessManagerSections } from '../hooks/useCanAccessManagerSections';

function requiresManagerAccess(pathname: string): boolean {
  if (/^\/(employees|products|orders)(\/|$)/.test(pathname)) {
    return true;
  }
  if (pathname === '/shifts/new') {
    return true;
  }
  if (/^\/shifts\/[^/]+\/edit$/.test(pathname)) {
    return true;
  }
  return false;
}

interface RequireManagerOrAdminProps {
  children: ReactNode;
}

/**
 * Обёртка для маршрутов менеджера/админа: /employees, /products, /orders,
 * а также создание и редактирование смены (/shifts/new, /shifts/:id/edit).
 * При отсутствии прав (employee) перенаправляет на список предстоящих смен.
 */
export function RequireManagerOrAdmin({ children }: RequireManagerOrAdminProps) {
  const { pathname } = useLocation();
  const canAccessManagerSections = useCanAccessManagerSections();

  if (requiresManagerAccess(pathname) && !canAccessManagerSections) {
    return <Navigate to="/shifts/upcoming" replace />;
  }

  return <>{children}</>;
}
